exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "\n.imageselect {\n  position: relative;\n}\n.imageselect .imageselect-close {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 2;\n  font-size: 14px;\n  line-height: 14px;\n  cursor: pointer;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/happypack/loader.js?id=css!./~/vue-loader/lib/style-compiler?{"id":"data-v-e240a9ee","scoped":false,"hasInlineConfig":false}!./~/happypack/loader.js?id=less!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/imageselect.vue
// module id = 524
// module chunks = 23